<template>
  <nav
    class="breadcrumbs"
    :class="{ [$class('loading')]: state === 'loading' }"
    :aria-label="$string('general.breadcrumbs.label')"
  >
    <ol class="breadcrumbs__list-element">
      <li class="breadcrumbs__list-item">
        <a
          class="breadcrumbs__link text-body-s-regular"
          :href="$variable('routes.root')"
          v-text="$string('general.breadcrumbs.home')"
        />

        <span
          class="breadcrumbs__separator text-body-s-regular"
          aria-hidden="true"
        >
          <icon-chevron-right />
        </span>
      </li>

      <li
        v-if="ancestorTitle && ancestorUrl"
        class="breadcrumbs__list-item"
      >
        <a
          class="breadcrumbs__link text-body-s-regular"
          :href="ancestorUrl"
          v-html="ancestorTitle"
        />

        <span
          class="breadcrumbs__separator text-body-s-regular"
          aria-hidden="true"
        >
          <icon-chevron-right />
        </span>
      </li>

      <li
        v-for="breadcrumb of breadcrumbs"
        :key="breadcrumb"
        class="breadcrumbs__list-item"
      >
        <a
          class="breadcrumbs__link text-body-s-regular"
          :href="getPageHandle(breadcrumb.handle)"
          v-html="breadcrumb.title"
        />

        <span
          class="breadcrumbs__separator text-body-s-regular"
          aria-hidden="true"
        >
          <icon-chevron-right />
        </span>
      </li>

      <li class="breadcrumbs__list-item">
        <span
          aria-current="page"
          class="breadcrumbs__link text-body-s-regular"
          :style="{ animationDelay: animationDelay }"
          v-html="title"
        />
      </li>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Breadcrumbs navigation links.
 *
 * @param {String} ancestorTitle - Title of ancestor, e.g. collection title if
 * product is in a collection.
 * @param {String} ancestorUrl - URL of ancestor, this avoids complicating the
 * breadcrumb component by making additional queries to load ancestor data.
 * @param {Object} breadcrumbs - Custom breadcrumbs.
 * @param {String} state - Loading state of parent component.
 * @param {String} title - Title displayed for current page.
 * @param {String} type - Page type of breadcrumb placement.
 *
 */
import IconChevronRight from '~icons/directional-navigation/chevron/right.svg'

import { values as timings } from '~/config/timings'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  components: {
    IconChevronRight,
  },

  props: {
    ancestorTitle: {
      type: String,
      default: '',
    },
    ancestorUrl: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: 'loading',
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Compute animation delay.
     * @returns {Boolean|String}
     */
    animationDelay() {
      return this.ancestorTitle && this.ancestorUrl
        ? `${timings.quick}s`
        : false
    },
  },

  methods: {

    /**
     * Return page handle.
     * @param {string} handle - Page handle.
     * @returns {String}
     */
    getPageHandle(handle) {
      let pageHandle
      if (this.type === 'product' || this.type === 'collection') {
        pageHandle = `/collections/${handle}`
      } else if (this.type === 'page') {
        pageHandle = `/pages/${handle}`
      }

      return pageHandle
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
